import { Currency, getCurrencySymbol } from "@redotech/money/currencies";
import { memo } from "react";
import { Text } from "./text";

export const CurrencySymbolIcon = memo(function CurrencySymbolIcon({
  currency,
}: {
  currency: Currency;
}) {
  return (
    <Text fontSize="xs" fontWeight="medium" textColor="secondary">
      {getCurrencySymbol(currency)}
    </Text>
  );
});
